import * as CalendarType from "../../action/actiontype/CalendarType/CalendarType";

const calendarReducer = (state = {}, action) => {
    switch (action.type) {
        case CalendarType.CALENDAR_ADD_REQUEST:
            return {
                ...state,
                calendarAddeError: true,
                calendarAddResponse: {},
                calendarAddeError: null
            } 
        case CalendarType.CALENDAR_ADD_SUCCESS:
            return {
                ...state,
                calendarAddeError: false,
                calendarAddResponse: action.payload,
                calendarAddeError: null
            }
        case CalendarType.CALENDAR_ADD_FAILURE:
            return {
                ...state,
                calendarAddeError: false,
                calendarAddeError: action.payload,
                calendarAddResponse: {}
            }

              // Calendar

              case CalendarType.HOSPITAL_PHARMACY_CALENDAR_REQUEST:
                return {
                  ...state,
                  hospitalPharamacyCalendarLoading: true,
                  hospitalPharamacyCalendarResponse: {},
                  hospitalPharamacyCalendarError: null,
                };
              case CalendarType.HOSPITAL_PHARMACY_CALENDAR_SUCCESS:
                return {
                  ...state,
                  hospitalPharamacyCalendarLoading: false,
                  hospitalPharamacyCalendarResponse: action.payload,
                  hospitalPharamacyCalendarError: null,
                };
              case CalendarType.HOSPITAL_PHARMACY_CALENDAR_FAILURE:
                return {
                  ...state,
                  hospitalPharamacyCalendarLoading: false,
                  hospitalPharamacyCalendarError: action.payload,
                  hospitalPharamacyCalendarResponse: {},
                };

                // calenbdar update
            case CalendarType.CALENDAR_UPDATE_REQUEST:
                return {
                    ...state,
                    calendarUpdateLoading: true,
                    calendarUpdateResponse: {},
                    calendarUpdateError: null
                }
            case CalendarType.CALENDAR_UPDATE_SUCCESS:
                return {
                    ...state,
                    calendarUpdateLoading: false,
                    calendarUpdateResponse: action.payload,
                    calendarUpdateError: null
                }
            case CalendarType.CALENDAR_UPDATE_FAILURE:
                return {
                    ...state,
                    calendarUpdateLoading: false,
                    calendarUpdateResponse: {},
                    calendarUpdateError: action.payload,
                }
       
            default:
                return state;
        }
    }
    
export default calendarReducer;